import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { HiOutlineEye } from "react-icons/hi";
import {
  capitalizeFirstLetter,
  baseURLImage,
  getNameProfile,
  downloadWorkerTemplate,
  getUrlRole,
  validateWorkerImportFile,
} from "../../../../Utils/utils";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import Search from "../../../../components/common/Search/Search";
import TableHeader from "../../../../components/common/Table/TableHeader";
import {
  LOADER_STATUS,
  SORT_TYPE,
  StatusOptions,
} from "../../../../Constants/constant";
import SelectOption from "../../../../components/common/Select/Select";
import {
  HRM_BREADCRUMB_PAGES,
  HRM_BREADCRUMB,
} from "../../../../Constants/BreadcrumbConstant";
import Breadcrumb from "../../../../components/common/Breadcrumb";
import Header from "../../../../components/common/Header/Header";
import AddNewWorkerModal from "./AddNewWorker";
import { BiPlus, BiUpload, BiDownload } from "react-icons/bi";
import { AiOutlineInfoCircle } from "react-icons/ai";
import CustomButton from "../../../../components/common/Button/CustomButton";
import { connect } from "react-redux";
import { getSPApplicantsListRequest } from "../../../../store/actions/sp.actions";
import {
  getApplicants,
  getLoading,
} from "../../../../store/selector/sp.selector";
import { roleAccess } from "helpers/RolesPermission";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import QuickView from "./WorkerQuickView";
import { trackSearch } from "Utils/trackSearch";
import ModalSkeleton from "../../../../components/Modals/ModalSkeleton";
import FileUploadInput from "../../../../components/common/FileUpload/FileUploadInput";
import { apiFormDataRequest } from "../../../../helpers/Requests";
import { toast } from "react-toastify";
import PopoverContainer from "../../../../components/common/Popover/PopoverContainer";

const TeamManagementListTable = (props) => {
  const {
    templateList,
    isLoading,
    queryParams,
    handleFetch,
    getSortBy,
    renderLoading,
    isUserGracePeriodOver,
    setSelectedStatus,
    selectedStatus
  } = props;

  // Max `minWords` (3) in the cell, then "..."; full text always shown on hover via PopoverContainer
  const truncateWithMinWords = (text, minWords = 3) => {
    if (!text || text === "N/A") return text;

    const words = text.split(/\s+/).filter(Boolean);

    if (words.length <= minWords) {
      return text;
    }

    const firstWords = words.slice(0, minWords).join(" ");
    return `${firstWords}...`;
  };

  const [search, setSearch] = useState(null);
  const [sortBy, setSortBy] = useState("first_name");
  const [isOpenModel, setIsModelOpen] = useState(false);
  const [isTemplateDownloading, setIsTemplateDownloading] = useState(false);
  // const [selectedStatus, setSelectedStatus] = useState(null);
  const [sortDescending, setSortDescending] = useState(false);
  const [addWorkerRefresh, setAddWorker] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };
  const checkStatus = (status) => {
    return status === "both" ? "both": status === "active"? true : false;
  };

  useEffect(() => getSortBy(sortBy), [sortBy]);
  //   useEffect(() => {
  //     if (addWorkerRefresh) {
  //         // Perform any actions needed to refresh the component
  //         // For example, you might call the function that fetches data or updates state.

  //         // Reset shouldRefresh back to false
  //         setAddWorker(false);
  //     }
  // }, [addWorkerRefresh]);

  useEffect(() => {
    if (queryParams.sort_field) {
      setSortBy(queryParams.sort_field);
      setSortDescending(queryParams.sort_order === SORT_TYPE.DESC);
    }
    // if (queryParams.hasOwnProperty("filter")) {
    //   if (queryParams.filter !== null) {
    //     setSelectedStatus(
    //       queryParams.filter.status && queryParams.filter.status.length > 0
    //         ? StatusOptions.find(
    //             (x) => x.value === queryParams.filter.status[0]
    //           )
    //         : null
    //     );
    //   }
    // }

    if (queryParams.search) {
      setSearch((current) => {
        if (current === queryParams.search) return current;
        // The server trims the term. Writing that echo back would search again.
        if (
          typeof current === "string" &&
          current.trim() === String(queryParams.search).trim()
        ) {
          return current;
        }
        return queryParams.search;
      });
    }
  }, [queryParams]);



  

  useEffect(() => {
    // if (
    //   (queryParams.search === null && !search) ||
    //   queryParams.search === search
    // ) {
    //   return;
    // }

    if (search === null) return;

    const timeOutId = setTimeout(
      () => {
        const term = typeof search === "string" ? search.trim() : search;
        trackSearch("worker", term);
        handleFetch(
          {
            search: term,
            status: selectedStatus?.value ?? "active",
          },
          sortBy
        );
      },
      1000
    );
    return () => clearTimeout(timeOutId);
  }, [search]);

  useEffect(
    () =>
      handleFetch(
        {
          search: search,
          status: selectedStatus?.value ?? "active",
        },
        sortBy
      ),
    [addWorkerRefresh]
  );

  const applySort = (sortField, sortOrder) => {
    setSortBy(sortField);
    setSortDescending(sortOrder === SORT_TYPE.DESC);
    handleFetch(
      {
        sort_field: sortField,
        sort_order: sortOrder,
        status: selectedStatus?.value,
        page: 1,
      },
      sortField
    );
  };

  const flipSort = (by) => {
    const isAz = sortBy === "first_name" && !sortDescending;
    const isZa = sortBy === "first_name" && sortDescending;
    if (by === "created_at" || isZa) {
      applySort("created_at", SORT_TYPE.DESC);
      return;
    }
    if (isAz) {
      applySort("first_name", SORT_TYPE.DESC);
      return;
    }
    applySort("first_name", SORT_TYPE.ASC);
  };

  const handleImportClick = () => {
    setIsImportModalOpen(true);
  };

  const hasCreatePermission = roleAccess(
    [],
    PERMISSION_KEYS.HRM,
    PERMISSION_KEYS_CHILDREN.HRM.WORKER.CREATE
  );

  return (
    <div className='w-full min-w-0'>
      {isOpenModel && (
        <AddNewWorkerModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          setAddWorker={setAddWorker}
          openModel={isOpenModel}
          handleClose={setIsModelOpen}
          addWorkerRefresh={addWorkerRefresh}
        />
      )}
      {/* min-w keeps layout from collapsing at browser zoom &gt; 100%; outer overflow-x-auto shows bottom scrollbar on 1280×720 when zoomed */}
      {/* custom-scroll: required in Chrome — index.css hides ::-webkit-scrollbar on div:not(.custom-scroll) */}
      <div className='custom-scroll w-full min-w-0 overflow-x-auto overscroll-x-contain'>
        <div className='min-w-[960px]'>
      <Header
        title='Team Management'
        desc='Active staff by default — use the status filter to include inactive workers'
        breadcrumb={
          <Breadcrumb
            pages={HRM_BREADCRUMB(HRM_BREADCRUMB_PAGES.TEAM_MANAGMENT)}
          />
        }
        {...(hasCreatePermission && {
          btnComponent: (
            <div className='flex flex-wrap items-center gap-2 sm:gap-2 md:gap-4'>
              <CustomButton
                clickHandler={handleImportClick}
                label={
                  <span className='whitespace-nowrap'>
                    <span className='hidden md:inline'>Import Worker list</span>
                    <span className='md:hidden'>Import</span>
                  </span>
                }
                Icon={<BiUpload />}
                variant='primary'
                cssClass='text-xs sm:text-sm'
              />
              <CustomButton
                clickHandler={() => setIsModelOpen(true)}
                label={
                  <span className='whitespace-nowrap'>
                    <span className='hidden md:inline'>Add Worker</span>
                    <span className='md:hidden'>Add</span>
                  </span>
                }
                Icon={<BiPlus />}
                variant='primary'
                cssClass='text-xs sm:text-sm'
              />
            </div>
          ),
        })}
      />

      <div className='w-full min-w-0'>
        <div className='flex flex-wrap items-end justify-between gap-3 sm:px-6 lg:px-8 py-2 sticky top-[80px] bg-white z-[8]'>
          <div className='flex flex-wrap items-end gap-3'>
            <div className='w-40'>
              <label className='block text-xs sm:text-sm font-semibold text-gray-700 mb-2'>
                Status
              </label>
              <SelectOption
                isDisabled={isLoading}
                isSearch={false}
                selectedOption={selectedStatus}
                handleChange={(e) => {
                  setSelectedStatus(e);
                  handleFetch({ status: e.value, page: 1 }, sortBy);
                }}
                data={StatusOptions}
                cssClass='z-20'
              />
            </div>
          </div>
          <div className='w-full sm:w-80'>
            <label className='block text-xs sm:text-sm font-semibold text-gray-700 mb-2'>
              Search Worker
            </label>
            <Search
              setSearch={setSearch}
              search={search}
              placeholder='Name, email or phone'
              width='w-full'
            />
          </div>
        </div>
      <div className='flex flex-col sm:px-6 lg:px-8 w-full min-w-0'>
          {/* table-fixed + col widths: fit viewport at 100% zoom (no h-scroll); scroll only on very narrow viewports */}
          {/* overflow-x-auto: scrollbar only when content overflows (e.g. browser zoom above 100%); at 100% the fixed table usually fits — no bar */}
          <div className='custom-scroll w-full min-w-0 overflow-x-auto'>
            <div className='w-full min-w-0'>
              <div className='border md:rounded-lg'>
                <div className='block'>
                  {isLoading ? (
                    <div
                      className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
                    >
                      <CircularLoader
                        classes='flex justify-center items-center'
                        classloader='loader-l'
                      />
                    </div>
                  ) : (
                    <table className='w-full min-w-0 table-fixed divide-y divide-gray-300'>
                    <colgroup>
                      <col style={{ width: "19%" }} />
                      <col style={{ width: "11%" }} />
                      <col style={{ width: "23%" }} />
                      <col style={{ width: "18%" }} />
                      <col style={{ width: "9%" }} />
                      <col style={{ width: "12%" }} />
                      <col style={{ width: "8%" }} />
                    </colgroup>
                    <thead className='z-[7] bg-gray-50 sticky top-[0px] capitalize'>
                      <tr>
                        <TableHeader
                          sortName='first_name'
                          flipSort={flipSort}
                          sortBy={sortBy}
                          sortDescending={sortDescending}
                          label={"Full Name"}
                          cssClass='bg-blue-50 pl-5'
                        />
                        <TableHeader
                          isSort={false}
                          //sortName='designation'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Role"}
                          cssClass='bg-blue-50 px-3 py-3.5'
                        />
                        <TableHeader
                          isSort={false}
                          // sortName='email'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Email Address"}
                          cssClass='bg-blue-50 px-3 py-3.5'
                        />
                        <TableHeader
                          isSort={false}
                          // sortName='region'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Region"}
                          cssClass='bg-blue-50 px-3 py-3.5'
                        />
                        <TableHeader
                          isSort={false}
                          // sortName='status'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Status"}
                          cssClass='bg-blue-50 px-3 py-3.5'
                        />

                        <TableHeader
                          isSort={false}
                          // sortName='phone'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Phone Number"}
                          cssClass='bg-blue-50 px-3 py-3.5'
                        />
                        <TableHeader
                          isSort={false}
                          // sortName='action'
                          // flipSort={flipSort}
                          // sortBy={sortBy}
                          // sortDescending={sortDescending}
                          label={"Action"}
                          cssClass='bg-blue-50 px-3 py-3.5 whitespace-nowrap'
                        />
                      </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-200 bg-white overflow-y-auto'>
                      {templateList !== null &&
                        templateList.length > 0 &&
                        templateList.map((participant, index) => (
                          <tr
                            key={index}
                            className='even:bg-white odd:bg-gray-50'
                          >
                            <td className='min-w-0 py-4 px-2 text-sm sm:pl-4 sm:px-3'>
                              <div className='flex min-w-0 items-center'>
                                <div className='h-10 w-10 flex-shrink-0'>
                                  <img
                                    onError={(e) =>
                                      handleImageError(
                                        e,
                                        participant.first_name,
                                        participant.last_name
                                      )
                                    }
                                    className='capitalize object-cover h-10 w-10 rounded-full'
                                    src={
                                      participant.photo
                                        ? baseURLImage(participant.photo)
                                        : getNameProfile(
                                            participant.first_name,
                                            participant.last_name || " "
                                          )
                                    }
                                    alt=''
                                  />
                                </div>
                                <div className='ml-2 min-w-0 flex-1 capitalize sm:ml-4'>
                                  <Link
                                    className='block min-w-0 capitalize font-medium text-gray-900'
                                    to={`/worker-profile/${participant.uuid}`}
                                    state={{ workerUUID: participant.uuid }}
                                    title={`${participant.first_name} ${participant.last_name}`}
                                  >
                                    <p className='truncate capitalize'>
                                      {`${participant.first_name} ${participant.last_name}`}
                                    </p>
                                  </Link>
                                </div>
                              </div>
                            </td>
                            <td className='min-w-0 px-2 py-4 text-sm text-gray-500 sm:px-3'>
                              <div className='truncate text-gray-900' title={capitalizeFirstLetter(participant.role)}>
                                {capitalizeFirstLetter(participant.role)}
                              </div>
                            </td>
                            <td className='min-w-0 px-2 py-4 text-sm text-gray-500 sm:px-3'>
                              <div className='truncate text-gray-900' title={participant.email || ""}>
                                {participant.email}
                              </div>
                            </td>
                            <td className='min-w-0 px-2 py-4 text-sm text-gray-500 sm:px-3'>
                              {(() => {
                                const fullRegionText =
                                  participant.regions &&
                                  participant.regions.length > 0
                                    ? participant.regions
                                        .map((region) => region.name)
                                        .join(", ")
                                    : "N/A";

                                if (fullRegionText === "N/A") {
                                  return (
                                    <div className='text-gray-900 capitalize'>
                                      N/A
                                    </div>
                                  );
                                }

                                const displayText = truncateWithMinWords(
                                  fullRegionText,
                                  3
                                );
                                const isTruncated =
                                  fullRegionText !== displayText;

                                return (
                                  <div
                                    className={
                                      isTruncated
                                        ? "font-medium min-w-0 overflow-hidden text-ellipsis whitespace-nowrap text-gray-900 capitalize"
                                        : "min-w-0 truncate capitalize text-gray-900"
                                    }
                                  >
                                    <PopoverContainer
                                      cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                      itemComponent={() => {}}
                                      toolTip={fullRegionText}
                                      toolTipHoverAndClick
                                    >
                                      <span>{displayText}</span>
                                    </PopoverContainer>
                                  </div>
                                );
                              })()}
                            </td>
                            <td className='min-w-0 px-2 py-4 text-sm text-gray-500 sm:px-3'>
                              <span
                                className={`${
                                  participant.status
                                    ? "bg-green-100"
                                    : "bg-red-100"
                                } inline-flex max-w-full truncate rounded-full px-2 text-xs font-semibold leading-5 text-black`}
                              >
                                {capitalizeFirstLetter(
                                  participant.status ? "active" : "Inactive"
                                )}
                              </span>
                            </td>

                            <td className='min-w-0 whitespace-nowrap px-2 py-4 text-sm text-gray-500 sm:px-3' title={participant.phone || ""}>
                              {participant.phone}
                            </td>
                            <td className='relative min-w-0 whitespace-nowrap py-4 pl-2 pr-3 text-center text-sm font-medium sm:pl-3 sm:pr-4'>
                              <div className='flex items-center justify-start gap-x-3'>
                                {/* <Link
                                    to={`/sp-profile/${participant.uuid}`}
                                    className="icon-pencil-wrapper"
                                    title="Edit"
                                  >
                                    <BiPencil className="icon-size" />
                                    <span className="sr-only">
                                      {participant.uuid}
                                    </span>
                                  </Link> */}

                                <div
                                  onClick={() => {
                                    setIsOpen(true);
                                    setSelectedParticipant(participant);
                                  }}
                                  tabIndex={0}
                                  role='button'
                                  className='icon-eye-wrapper'
                                  title='View'
                                >
                                  <HiOutlineEye className='icon-size' />
                                  <span className='sr-only'>
                                    {/* {participant.uuid} */}
                                  </span>
                                </div>
                              </div>
                            </td>
                            {/* <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <Link
                                className='icon-eye-wrapper inline-block'
                                to={`/worker-profile/${participant.uuid}`}
                                state={{ workerUUID: participant.uuid }}
                              >
                                <HiOutlineEye className='icon-size' />
                              </Link>
                            </td> */}
                          </tr>
                        ))}
                      {templateList.length === 0 &&
                        renderLoading === LOADER_STATUS.COMPLATE &&
                        templateList?.length === 0 && (
                          <tr>
                            <td
                              colSpan={8}
                              className='py-6 text-center text-red-600'
                            >
                              No data found !
                            </td>
                          </tr>
                        )}
                    </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>

      {/* side over Modal */}
      {isOpen && (
        <QuickView
          paddingLeft='px-0'
          selectedParticipant={selectedParticipant}
          isOpen={isOpen}
          setIsOpen={() => {
            setIsOpen(false);
            setSelectedParticipant({});
          }}
        />
      )}
      {/* Import Worker Modal */}
      {isImportModalOpen && (
        <ModalSkeleton
          isOpen={isImportModalOpen}
          closeModal={() => {
            setIsImportModalOpen(false);
            setImportFile(null);
            setValidationErrors([]);
            setSuccessMessage(null);
          }}
          title='Import Worker list'
          cssClass='w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[55%]'
        >
          <div className='flex flex-col max-h-[70vh]'>
            {/* Scrollable Content */}
            <div className='flex-1 overflow-y-auto p-6 space-y-6'>
            {/* Download Template Section */}
            <div className='bg-blue-50 border border-blue-200 rounded-lg p-4'>
              <div className='flex items-center justify-between'>
                <div className='flex items-center gap-3'>
                  <div className='bg-blue-100 p-2 rounded-lg'>
                    <BiDownload className='text-blue-600 text-xl' />
                  </div>
                  <div>
                    <h3 className='text-sm font-semibold text-gray-900'>
                      Download Template
                    </h3>
                    <p className='text-xs text-gray-600 mt-0.5'>
                      Use the template to ensure correct format
                    </p>
                  </div>
                </div>
                <button
                  onClick={async () => {
                    setIsTemplateDownloading(true);
                    try {
                      await downloadWorkerTemplate();
                    } catch (error) {
                      console.error("Error downloading template:", error);
                    } finally {
                      setIsTemplateDownloading(false);
                    }
                  }}
                  disabled={isTemplateDownloading}
                  className='flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                >
                  {isTemplateDownloading ? (
                    <>
                      <svg
                        role="status"
                        className="animate-spin h-4 w-4 text-white"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>Downloading...</span>
                    </>
                  ) : (
                    <>
                      <BiDownload className='text-base' />
                      <span>Download</span>
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* File Upload Section */}
            <div>
              <label className='block text-sm font-semibold text-gray-900 mb-2'>
                Browse / Upload File
              </label>
              <FileUploadInput
                handleFile={(file) => {
                  setImportFile(file);
                  setValidationErrors([]); // Clear errors when new file is selected
                  setSuccessMessage(null); // Clear success message when new file is selected
                }}
                handleDelete={() => {
                  setImportFile(null);
                  setValidationErrors([]); // Clear errors when file is deleted
                  setSuccessMessage(null); // Clear success message when file is deleted
                }}
                file={importFile}
                type='xlsx'
                size={20}
                showDragAndDrop={true}
              />
              <p className='mt-2 text-xs text-gray-500 flex items-center gap-1'>
                <AiOutlineInfoCircle className='text-gray-400' />
                Supported formats: <span className='font-semibold'>.xlsx</span>
              </p>
            </div>

            {/* Success Message */}
            {successMessage && (
              <div className='bg-green-50 border-l-4 border-green-400 p-4 rounded-r-lg'>
                <div className='flex items-start gap-2'>
                  <AiOutlineInfoCircle className='text-green-600 text-lg mt-0.5 flex-shrink-0' />
                  <div className='flex-1'>
                    <h4 className='text-sm font-semibold text-green-800 mb-2'>
                      Success:
                    </h4>
                    <div className='text-sm text-green-700 whitespace-pre-line'>
                      {successMessage}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Validation Errors / Warnings */}
            {validationErrors.length > 0 && (
              <div className='bg-red-50 border-l-4 border-red-400 p-4 rounded-r-lg'>
                <div className='flex items-start gap-2'>
                  <AiOutlineInfoCircle className='text-red-600 text-lg mt-0.5 flex-shrink-0' />
                  <div className='flex-1'>
                    <h4 className='text-sm font-semibold text-red-800 mb-2'>
                      Errors Found:
                    </h4>
                    <ul className='text-sm text-red-700 space-y-1 max-h-48 overflow-y-auto'>
                      {validationErrors.map((error, index) => (
                        <li key={index} className='flex items-start gap-2'>
                          <span className='text-red-600 mt-1'>•</span>
                          <span>{error}</span>
                        </li>
                      ))}
                    </ul>
                    <p className='text-xs text-red-600 mt-2 font-medium'>
                      Please fix these errors before importing.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Important Note */}
            <div className='bg-amber-50 border-l-4 border-amber-400 p-4 rounded-r-lg'>
              <div className='flex items-start gap-2'>
                <AiOutlineInfoCircle className='text-amber-600 text-lg mt-0.5 flex-shrink-0' />
                <div className='text-sm text-amber-800 space-y-1'>
                  <p>
                    <strong>IMPORTANT:</strong> Do not change the column headings provided in the template. These must remain unchanged for the import to work correctly.
                  </p>
                  <p>
                    <strong>Before proceeding with your data, please remove the dummy data row.</strong> The template includes a dummy row for reference - delete it and enter your actual worker data.
                  </p>
                  <p>
                    Fields marked with an asterisk (*) are required fields and must be filled in.
                  </p>
                </div>
              </div>
            </div>
            </div>

            {/* Fixed Footer with Action Buttons */}
            <div className='flex-shrink-0 border-t border-gray-200 bg-white p-6'>
              <div className='flex justify-end gap-3'>
              <CustomButton
                label='Cancel'
                clickHandler={() => {
                  setIsImportModalOpen(false);
                  setImportFile(null);
                  setValidationErrors([]);
                  setSuccessMessage(null);
                }}
                variant='secondary'
              />
              <CustomButton
                label='Import'
                clickHandler={async () => {
                  if (!importFile) {
                    setValidationErrors(["Please select a file to import"]);
                    return;
                  }
                  
                  // Clear previous errors before importing
                  setValidationErrors([]);
                  setSuccessMessage(null);
                  
                  setIsImporting(true);
                  try {
                    const formData = new FormData();
                    formData.append("file", importFile);
                    
                    const rolePrefix = getUrlRole();
                    const response = await apiFormDataRequest(`${rolePrefix}/import-data/worker`, formData);
                    
                    console.log("Import response:", response);
                    
                    // Check for success - axios response structure
                    const isSuccess = response && (
                      response.status === 200 || 
                      response.status === 201 || 
                      (response.data && !response.data.error) ||
                      (!response.error && response.data)
                    );
                    
                    if (isSuccess) {
                      const importData = response?.data?.data || response?.data || {};
                      const imported = importData.imported || 0;
                      const importedNames = importData.imported_names || [];
                      const skipped = importData.skipped || 0;
                      const skippedEmails = importData.skipped_emails || [];
                      const skippedDetails = importData.skipped_details || [];
                      
                      // Always show success message if any records were imported (even if there are errors)
                      if (imported > 0) {
                        let successMessage = `${imported} worker(s) imported successfully.`;
                        if (importedNames.length > 0) {
                          const nameList = importedNames.slice(0, 10).join(', ');
                          const moreText = importedNames.length > 10 ? ` and ${importedNames.length - 10} more` : '';
                          successMessage += `\n\nImported workers: ${nameList}${moreText}.`;
                        }
                        setSuccessMessage(successMessage);
                      } else {
                        setSuccessMessage(null);
                      }
                      
                      // Show error messages for skipped records
                      const errorMessages = [];
                      if (skipped > 0) {
                        // Prioritize skippedDetails to show actual error reasons (with row numbers)
                        if (skippedDetails.length > 0) {
                          // Use detailed skipped information to show actual error reasons
                          skippedDetails.slice(0, 20).forEach(detail => {
                            if (detail.reason) {
                              // Show the actual error reason from backend (already includes row numbers)
                              errorMessages.push(detail.reason);
                            }
                          });
                          if (skippedDetails.length > 20) {
                            errorMessages.push(`and ${skippedDetails.length - 20} more record(s) skipped.`);
                          }
                        } else if (skippedEmails.length > 0) {
                          // Fallback to generic message if no detailed reasons available
                          const emailList = skippedEmails.slice(0, 5).join(', ');
                          const moreText = skippedEmails.length > 5 ? ` and ${skippedEmails.length - 5} more` : '';
                          errorMessages.push(`${skipped} record(s) skipped (duplicate emails: ${emailList}${moreText}).`);
                        } else {
                          errorMessages.push(`${skipped} record(s) skipped due to duplicates or errors.`);
                        }
                      }
                      
                      setValidationErrors(errorMessages);
                      setIsImporting(false);
                      
                      // Only close modal if there are no errors (all records imported successfully)
                      if (imported > 0 && skipped === 0) {
                        // Close modal and refresh after a short delay to show success message
                        setTimeout(() => {
                          setIsImportModalOpen(false);
                          setImportFile(null);
                          setValidationErrors([]);
                          setSuccessMessage(null);
                      
                          // Refresh the list - reset to page 1 and clear search to show all workers
                          handleFetch(
                            {
                              search: search || '',
                              status: selectedStatus?.value || 'active',
                              page: 1,
                            },
                            sortBy
                          );
                        }, 2000);
                      }
                      // If there are errors, keep modal open so user can see both success and error messages
                    } else {
                      const errorMessage = response?.data?.message || response?.message || "Failed to import workers. Please check the file format and try again.";
                      setValidationErrors([errorMessage]);
                      setIsImporting(false);
                    }
                  } catch (error) {
                    console.error("Import error:", error);
                    const errorMessage = error?.response?.data?.message || error?.message || "Failed to import workers. Please check the file format and try again.";
                    setValidationErrors([errorMessage]);
                    setIsImporting(false);
                  }
                }}
                variant='primary'
                isDisabled={!importFile || isImporting}
                showLoading={isImporting}
              />
              </div>
            </div>
          </div>
        </ModalSkeleton>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  getApplicantsList: getSPApplicantsListRequest,
};

const mapStateToProps = (state) => {
  const spApplicants = getApplicants(state);
  const loading = getLoading(state);
  return { loading, spApplicants };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeamManagementListTable);
